import { useEffect, useState } from "react";
import MentorReportEvent from "./reportEvent.jsx";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { CardFooter } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { newMentoringSubmit } from "../../config/apiSPA.js";
import ModalInfo from "../../components/modal/modalInfo.jsx";
const eventInitialState = {
  competencyName: "",
  mpName: "",
  instructor: "",
  activityId: "",
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
  remark: "",
};
function MentoringReport() {
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(true);
  const [eventData, setEventData] = useState(eventInitialState);
  const [modalWarning, setModalWarning] = useState({ show: false, message: "---" });
  const [spinner, setSpinner] = useState(false);
  const navigate = useNavigate();
  const handleSubmitClick = async (e) => {
    setSpinner(true);
    try {
      const res = await newMentoringSubmit(e);
      setSpinner(false);
      navigate(`/mentoring/detail/${res.data.id}`);
    } catch (error) {
      setSpinner(false);
      setModalWarning({ show: true, message: error.message });
    }
  };
  useEffect(() => {
    const isInvalid = [eventData.competencyName, eventData.mpName, eventData.instructor, eventData.activityId, eventData.startDate, eventData.endDate, eventData.startTime, eventData.endTime].some((value) => !value);
    setSubmitBtnDisabled(isInvalid);
  }, [eventData]);
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="row">
              <div className="col-xl-9">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#/">Mentoring</a>
                  </li>
                  <li className="breadcrumb-item active">New</li>
                </ul>

                <h1 className="page-header">Input New Mentoring</h1>

                <hr className="mb-4" />

                <div id="formControls" className="mb-5">
                  <p>
                    On Job Instruction (OJI) is a mentoring activity conducted in the workplace to enhance the skills and knowledge of mechanics. This activity involves direct supervision, guidance, and practical training while performing
                    actual job tasks. The implementation of OJI follows the competency matrix to ensure that each mechanic achieves the required competency level.
                  </p>
                  <Card>
                    <CardBody className="pb-2">
                      <MentorReportEvent onUpdate={(e) => setEventData(e)} />
                    </CardBody>
                    <CardFooter>
                      {spinner ? (
                        <button type="button" className="btn btn-lg btn-outline-theme" disabled>
                          <i className="spinner-border spinner-border-sm"></i>
                        </button>
                      ) : (
                        <button disabled={submitBtnDisabled} onClick={() => handleSubmitClick(eventData)} type="button" className="btn btn-lg btn-outline-theme">
                          Submit
                        </button>
                      )}
                    </CardFooter>
                  </Card>
                </div>
              </div>
              <div className="col-xl-3"></div>
            </div>
          </div>
        </div>
      </div>
      <ModalInfo show={modalWarning.show} onHide={() => setModalWarning((a) => ({ ...a, show: false }))} title={"WARNING !!"} theme={"danger"} text={`Error Message: ${modalWarning.message}`} />
    </>
  );
}

export default MentoringReport;
